import IMG_1 from 'assets/images/close-modal.svg'
import IMG_1_1 from 'assets/images/close-modal-mobile.png'
import IMG_2 from 'assets/images/scooter/series/plus/img-db-scooter-main.png'
import IMG_3 from 'assets/images/scooter/series/plus/img-db-gallery-1.png'
import IMG_4 from 'assets/images/scooter/series/plus/img-db-gallery-2.png'
import IMG_5 from 'assets/images/scooter/series/plus/img-db-gallery-3.png'
import IMG_6 from 'assets/images/scooter/series/plus/img-db-gallery-4.png'
import IMG_7 from 'assets/images/scooter/series/plus/img-db-gallery-5.png'
import { URL, OUTER_URL } from '../../utils/Utils'
import './PlusUtlityPopup.scss'

/**
 * @file 고고로 2 플러스 및 고고로 2 유틸리티 차량 화면 의 하단에 고고로 2 플러스 이미지 선택시, 표시되는 팝업
 * @param {boolean} isPlusPopup plus 팝업 보이는 여부의 값
 * @param {*} setIsPlusPopup plus 팝업 보이는 여부의 값을 set
 */
function ScooterPlusPopup({ isPlusPopup, setIsPlusPopup }) {
    return isPlusPopup ? (
        <div className="modal-wrap" id="modal-plus">
            <div className="modal-container">
                <button className="close-modal" onClick={() => setIsPlusPopup(false)}>
                    <img className="pc" src={IMG_1} alt="닫기" />
                    <img className="mobile" src={IMG_1_1} alt="닫기" />
                </button>
                <img src={IMG_2} alt="" />
                <div className="title-name-box">
                    <div>
                        <div className="t1">고고로 2 PLUS</div>
                        <a className="link" href="" onClick={() => window.open(OUTER_URL.GOGORO_HOMPAGE)}>
                            구매문의
                        </a>
                    </div>
                </div>
                <div className="describes">
                    <div>
                        <div className="t1">Smart Key</div>
                        <div className="sub">
                            스마트 키와 App을 통한
                            <br />
                            간편한 잠금 해제
                        </div>
                    </div>
                    <div>
                        <div className="t1">세련된 디자인</div>
                        <div className="sub">
                            부드럽고 유연한 디자인으로
                            <br />
                            세련된 느낌의 차량
                        </div>
                    </div>
                    <div>
                        <div className="t1">후진 기능 지원</div>
                        <div className="sub">
                            복잡한 공간에서도 자유롭게
                            <br />
                            편리한 후진 기능 지원
                        </div>
                    </div>
                </div>
                <div className="grid-box">
                    <div>
                        <div className="img" style={{ backgroundImage: `url(${IMG_3})` }} />
                    </div>
                    <div>
                        <div className="img" style={{ backgroundImage: `url(${IMG_4})` }} />
                    </div>
                    <div>
                        <div className="img" style={{ backgroundImage: `url(${IMG_5})` }} />
                    </div>
                    <div>
                        <div className="img" style={{ backgroundImage: `url(${IMG_6})` }} />
                    </div>
                    <div>
                        <div className="img" style={{ backgroundImage: `url(${IMG_7})` }} />
                    </div>
                </div>
                <div className="details">
                    <div className="t1">디테일</div>
                    <div className="details-box">
                        <div>
                            <div className="box-row">
                                <div className="s1">길이 x 너비 x 높이 (백미러 제외)</div>
                                <div className="d1">1,880 x 670 x 1,090mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">휠베이스</div>
                                <div className="d1">1,310mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">안장 높이</div>
                                <div className="d1">750mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">무게 (비어 있음/배터리 포함)</div>
                                <div className="d1">110/126kg</div>
                            </div>
                        </div>
                        <div>
                            <div className="box-row">
                                <div className="s1">최대 출력</div>
                                <div className="d1">6.4kw @3,000rpm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">최대 토크 (모터/휠)</div>
                                <div className="d1">26.6 / 196Nm @ 0-2,500rpm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">등판성</div>
                                <div className="d1">
                                    30%(17°): 30km/h
                                    <br />
                                    20%(11°): 40km/h
                                    <br />
                                    10%(6°): 60km/h
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="extra-describes">
                        * 이 표는 참고용이며 테스트 시나리오에 따라 결과가 달라질 수 있습니다.
                        <br />* 자세한 정보는 고객센터를 통해 확인해주시기 바랍니다.
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <></>
    )
}

export default ScooterPlusPopup
